import {
  MockMap,
} from '@ama-sdk/core';
import {
  createMockData,
} from '@dapi/sdk/spec';
import {
  acknowledgeSuccess,
  alternativeOfferConfirmationJobMock,
  alternativeOfferInProgressJobMock,
  getAlternativeOffersMockDisruptedInbound,
  retrieveOrderMockDisruptedOutbound,
} from '../../../mock/data/index';
import {
  flightDisruptionWarning,
} from '../../../mock/dictionaries';

export const disruptedOutboundMock: MockMap = {
  retrieveOrder: [
    createMockData(retrieveOrderMockDisruptedOutbound, [], [flightDisruptionWarning])
  ],
  getOrderEligibilities: [],
  getAlternativeOffers: [createMockData(getAlternativeOffersMockDisruptedInbound)],
  createAsynchronousJobForAlternativeOfferConfirmation: [createMockData(alternativeOfferInProgressJobMock)],
  getAlternativeOfferConfirmationJob: [createMockData(alternativeOfferConfirmationJobMock)],
  acknowledge: [createMockData(acknowledgeSuccess)]
};
